/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Preset_Manager_Import_Success_ToastInputs */



/**
* | output |
* | --- |
* | "{count} preset(s) imported successfully" |
*
* @param {Preset_Manager_Import_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_import_success_toast = /** @type {((inputs: Preset_Manager_Import_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Import_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} preset(s) importe(s) avec succes`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count}-Voreinstellung(en) erfolgreich importiert`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} preset importati correttamente`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Предустановки ${i?.count} успешно импортированы.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} ajustes preestablecidos importados exitosamente`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已成功导入 ${i?.count} 预设`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} プリセットが正常にインポートされました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} प्रीसेट सफलतापूर्वक आयात किए गए`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Predefinições ${i?.count} importadas com sucesso`)
	return /** @type {LocalizedString} */ (`${i?.count} preset(s) imported successfully`)
});